/**
 * Generates empty spaces for string
 *
 * @param   amount  Number of spaces.
 * @returns An empty space string based on \xa0
 */
export const generateEmptySpaces = (amount: number) => '\xa0'.repeat(amount);

export const capitalizeFirstLetterWithComma = (string: string) =>
  string.replaceAll('_', ' ').charAt(0).toUpperCase() + string.replaceAll('_', ' ').slice(1);

export const joinArrayWithComma = (array: string[]) =>
  array.map(capitalizeFirstLetterWithComma).join(', ');
